import React from "react"
import { Avatar } from "../AvatarGroup"
import { getSessionVisibilityClassKey, formatSessionCityLabel } from "../../../helpers/sessionDetail"

const resolveCityHubContextLabel = session => {
  if (!session) return ""

  const isCitySession =
    Boolean(session.isCitySession) ||
    String(session.sourceType || "").toLowerCase() === "city"

  if (!isCitySession) return ""

  return (
    formatSessionCityLabel(session.city) ||
    String(session.cityName || "").trim() ||
    ""
  )
}

const SessionDetailMeta = ({
  session,
  layout = "inline",
  tagsAction = null,
  timer = null,
  part = "all",
}) => {
  const type = session?.type || "Shadow Session"
  const visibility =
    session?.visibility && session.visibility !== "—"
      ? session.visibility
      : "Private"
  const startedAt = session?.startedAt || "—"
  const startedBy = session?.startedBy || { name: "—", src: null }
  const sessionNoteRaw = String(session?.sessionNote || "").trim()
  const sessionTitleRaw = String(session?.taskTitle || "").trim()
  const isTaskSession = Boolean(session?.isTaskSession)
  const showTaskTitle =
    isTaskSession && sessionTitleRaw && sessionTitleRaw !== "—"
  const isSolo = /solo/i.test(type)
  const noteDisplay = showTaskTitle
    ? sessionTitleRaw
    : sessionNoteRaw || "—"

  const showTags = part === "all" || part === "tags"
  const showRows = part === "all" || part === "rows"
  const showTimer = part === "all" && timer
  const cityLabel = resolveCityHubContextLabel(session)

  return (
    <div className={`session-detail-meta session-detail-meta--${layout}`}>
      {showTags ? (
        <div
          className={`session-detail-meta__top${
            tagsAction ? " session-detail-meta__top--with-action" : ""
          }`}
        >
          <div className="session-detail-meta__tags">
            <span
              className={`session-detail-meta__tag session-detail-meta__tag--${
                isSolo ? "solo" : "shadow"
              }`}
            >
              {type}
            </span>
            <span
              className={`session-detail-meta__tag session-detail-meta__tag--${getSessionVisibilityClassKey(
                visibility,
              )}`}
            >
              {visibility}
            </span>
          </div>
          {tagsAction}
        </div>
      ) : null}

      {showTimer ? (
        <div className="session-detail-meta__timer">{timer}</div>
      ) : null}

      {showRows ? (
        <div className="session-detail-meta__rows">
          {cityLabel ? (
            <div className="session-detail-meta__row">
              <span className="session-detail-meta__label">City:</span>
              <span className="session-detail-meta__value">{cityLabel}</span>
            </div>
          ) : null}
          <div className="session-detail-meta__row">
            <span className="session-detail-meta__label">Started at:</span>
            <span className="session-detail-meta__value">{startedAt}</span>
          </div>
          <div className="session-detail-meta__row">
            <span className="session-detail-meta__label">Started by:</span>
            <span className="session-detail-meta__person">
              <Avatar
                src={startedBy.src || startedBy.avatar}
                name={startedBy.name}
                size="sm"
              />
              <span>{startedBy.name}</span>
            </span>
          </div>

          <div className="session-detail-meta__row session-detail-meta__row--note">
            <span className="session-detail-meta__label session-detail-meta__label--note">
              Session Note:
            </span>
            <span className="session-detail-meta__value session-detail-meta__value--note">
              {noteDisplay}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SessionDetailMeta
